export * from "./bsAssortmentTable";
